import src from "IMAGE";
export default { src, width: 732, height: 218, blurWidth: 0, blurHeight: 0};
